// AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Check local storage to set initial authentication state
    return localStorage.getItem('authToken') !== null;
  });

  const login = (data) => {
    localStorage.setItem('authToken', data.token); // Store token in local storage
    localStorage.setItem('role', data.role); // Store token in local storage
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('authToken'); // Remove token from local storage
    localStorage.removeItem('role'); // Remove token from local storage
    setIsAuthenticated(false);
  };

  useEffect(() => {
    // Optionally add any effect needed when authentication state changes
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
